import {useMutation} from "@tanstack/react-query";
import {deleteFacilityUsers} from "../services/FacilityService";

export function useFacilityUsersDelete() {
    return useMutation({
        mutationFn: ({facilityId, userIds}) => deleteFacilityUsers(facilityId, userIds),
    });
}
